import { render } from "./ProductSubthree.vue?vue&type=template&id=8f2890a4&scoped=true"
import script from "./ProductSubthree.vue?vue&type=script&lang=js"
export * from "./ProductSubthree.vue?vue&type=script&lang=js"

import "./ProductSubthree.vue?vue&type=style&index=0&id=8f2890a4&scoped=true&lang=css"
import "./ProductSubthree.vue?vue&type=style&index=1&id=8f2890a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2890a4"]])

export default __exports__